"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonIcon = exports.EditableContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_rainbow_components_1 = require("react-rainbow-components");
exports.EditableContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-right: 32px;\n\n    :hover {\n        > button {\n            display: inline-flex;\n        }\n    }\n\n    ", "\n\n    ", "\n"], ["\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-right: 32px;\n\n    :hover {\n        > button {\n            display: inline-flex;\n        }\n    }\n\n    ",
    "\n\n    ",
    "\n"])), function (props) {
    return props.cellAlignment === 'right' &&
        "\n        padding-right: 8px;\n        padding-left: 32px;\n    ";
}, function (props) {
    return props.isDirty &&
        "\n            background-color: #fff9e6;\n\n            :hover,\n            :active,\n            :focus {\n                background-color: #fcf3d0;\n            }\n    ";
});
exports.StyledButtonIcon = styled_components_1.default(react_rainbow_components_1.ButtonIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    display: none;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    ", "\n\n    ", "\n"], ["\n    color: ", ";\n    display: none;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    ",
    "\n\n    ",
    "\n"])), function (props) { return props.theme.rainbow.palette.brand.main; }, function (props) {
    return props.cellAlignment === 'right' &&
        "\n        left: 0;\n    ";
}, function (props) {
    return props.disabled &&
        "\n        cursor: default;\n    ";
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map